import { memo } from 'react';
import { useCart } from '../../../../context/cart';
import { useLocalization } from '../../../../context/Localization/localization';
import { IconButton } from '../../../../controls/IconButton/IconButton';
import { GMSizedIcon } from '../../../../controls/Icon';
import { isElectron } from '../../../../helpers/EnvironmentFlags/EnvironmentFlags';
import type { GoMotoComponent } from '../../../../API/GoMoto.types';
import type { CartIconProps } from './CartIcon.types';

export const CartIcon: GoMotoComponent<CartIconProps> = memo(({ onClick, count, slim }: CartIconProps) => {
    const { displayCartIcon } = useCart();
    const Localization = useLocalization();

    return (
        displayCartIcon && (
            <div>
                <IconButton
                    headerIcon
                    slim={slim}
                    onClick={onClick}
                    sizedIcon={<GMSizedIcon iconType={'Cart'} iconSize={slim ? 'custom' : 'medium'} />}
                    label={isElectron() ? undefined : Localization.Cart}
                    count={count}
                    title={Localization.ClickToViewCart}
                    ariaLabel={Localization.ClickToViewCart}
                    id={Localization.ClickToViewCart}
                />
            </div>
        )
    );
});
